import { EnvironmentUrls } from 'Roblox';
import groupModule from '../groupModule';

function groupDetailsService(httpService, $filter, groupDetailsConstants) {
  'ngInject';

  function sendGroupShout(groupId, message) {
    const config = {
      url: $filter('formatString')(groupDetailsConstants.urls.updateGroupStatus, { id: groupId })
    };

    const data = {
      message
    };
    return httpService.httpPatch(config, data);
  }

  function profilePageUrl(userId) {
    return `${EnvironmentUrls.websiteUrl}/users/${userId}/profile`;
  }

  function abusePageUrl(type, id) {
    return $filter('formatString')(groupDetailsConstants.absoluteUrls.reportAbuse, {
      type,
      id,
      absUrl: encodeURIComponent(window.location.href)
    });
  }

  function advertiseGroupUrl(targetId) {
    return `${EnvironmentUrls.websiteUrl}/user-ads/create?targetId=${targetId}&targetType=Group`;
  }

  function configureGroupUrl(groupId) {
    return `${EnvironmentUrls.websiteUrl}/groups/configure?id=${groupId}`;
  }

  return {
    sendGroupShout,
    profilePageUrl,
    abusePageUrl,
    advertiseGroupUrl,
    configureGroupUrl
  };
}

groupModule.factory('groupDetailsService', groupDetailsService);

export default groupDetailsService;
